import {EventBasesServiceInterface} from "@/services/EventBasesService/EventBasesService.interface";

export const EventBasesServiceSchema: EventBasesServiceInterface = {
    id: null,
    eventId: null,
    eventTitle: null,
    dateWithTimezone: null,
    state: null,
    tickets: [],
}
